function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "border-color-24-px_svg__a",
  d: "M17.75 7.002L14 3.252l-9.85 9.85c-.1.1-.15.22-.15.36V16.5c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.75 7zm2.96-2.96a.996.996 0 000-1.41L18.37.292a.996.996 0 00-1.41 0L15 2.252l3.75 3.75 1.96-1.96zM2 20h20c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "border-color-24-px_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#border-color-24-px_svg__a"
})), React.createElement("g", {
  fill: "#000",
  fillOpacity: 0.54,
  mask: "url(#border-color-24-px_svg__b)"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var SvgBorderColor24Px = function SvgBorderColor24Px(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default SvgBorderColor24Px;